import { render, staticRenderFns } from "./CustomChartSimple.vue?vue&type=template&id=73ddf9ef&"
import script from "./CustomChartSimple.vue?vue&type=script&lang=js&"
export * from "./CustomChartSimple.vue?vue&type=script&lang=js&"
import style0 from "./CustomChartSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports